"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BellFill;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function BellFill(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "bell"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "compound",
    d: "M51.45,8.5A5.83,5.83,0,0,1,56,11a4.71,4.71,0,0,1,.76,2.61v.12a4.86,4.86,0,0,0,3.31,4.61c5.25,1.78,15.13,6.82,17.55,20a5.14,5.14,0,0,1,.08.88c0,3.07.27,22,9.39,29.73a4.82,4.82,0,0,1,1.74,4.21c-.17,1.38-1,2.94-3.28,4.21a4.8,4.8,0,0,1-2.29.57H19.47a4.8,4.8,0,0,1-2.29-.57c-2.31-1.27-3.11-2.83-3.28-4.21A4.82,4.82,0,0,1,15.64,69c9.12-7.77,9.41-26.66,9.39-29.73a4.3,4.3,0,0,1,.08-.88c2.42-13.19,12.3-18.23,17.55-20A4.86,4.86,0,0,0,46,13.77v-.12A4.71,4.71,0,0,1,46.73,11,5.83,5.83,0,0,1,51.26,8.5ZM40.59,81.61C41,84,43,91.5,51.26,91.5s10.11-7.57,10.48-9.9a.58.58,0,0,0-.58-.67h-20A.59.59,0,0,0,40.59,81.61Z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "original"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.9,8.5A5.81,5.81,0,0,0,46.38,11a4.63,4.63,0,0,0-.76,2.61v.12a4.88,4.88,0,0,1-3.31,4.61c-5.25,1.78-15.13,6.82-17.56,20a5.14,5.14,0,0,0-.07.88c0,3.07-.28,22-9.39,29.73a4.82,4.82,0,0,0-1.74,4.21c.16,1.38,1,2.94,3.28,4.21a4.73,4.73,0,0,0,2.28.57H82.89a4.73,4.73,0,0,0,2.28-.57c2.31-1.27,3.12-2.83,3.28-4.21A4.82,4.82,0,0,0,86.71,69c-9.11-7.77-9.4-26.66-9.39-29.73a5.14,5.14,0,0,0-.07-.88c-2.43-13.19-12.31-18.23-17.56-20a4.88,4.88,0,0,1-3.31-4.61v-.12A4.63,4.63,0,0,0,55.62,11,5.81,5.81,0,0,0,51.1,8.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.82,80.93h20a.59.59,0,0,1,.58.67c-.37,2.33-2.21,9.9-10.49,9.9S40.65,84,40.24,81.61A.58.58,0,0,1,40.82,80.93Z"
  })))));
}